import React from "react";

interface MeterProps {
  activityLevel: number;
  color?: string;
  borderColor?: string;
  emptyColor?: string;
  emptyBorderColor?: string;
  size?: "small" | "medium" | "large";
}

const sizeMap = {
  small: { width: 12, height: 8, viewBox: "0 0 12 8" },
  medium: { width: 19, height: 12, viewBox: "0 0 19 12" },
  large: { width: 32, height: 35, viewBox: "0 0 33 36" }
};

const rectStyle = { transition: "fill 0.5s, stroke 0.5s" };

const ActivityLevelMeterIcon = ({
  activityLevel,
  color = "var(--theme-palette-primary-main)",
  borderColor = "var(--theme-palette-primary-main)",
  emptyColor = "transparent",
  emptyBorderColor = "var(--theme-palette-primary-main)",
  size = "medium"
}: MeterProps) => {
  const { width, height, viewBox } = sizeMap[size];

  const barCount = 4;
  const barWidth = width / (barCount * 1.5); // e.g., 1.5 for spacing
  const barSpacing = (width - barWidth * barCount) / (barCount - 1);

  // Heights for each level (can be adjusted for your design)
  const barHeights = [
    height * 0.25,
    height * 0.5,
    height * 0.75,
    height
  ];

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox={viewBox}
      fill="none"
      data-testid="activity-level-meter"
    >
      {[0, 1, 2, 3].map((i) => (
        <rect
          key={i}
          x={i * (barWidth + barSpacing)}
          y={height - barHeights[i]}
          width={barWidth}
          height={barHeights[i]}
          fill={i > activityLevel - 1 ? emptyColor : color}
          stroke={i > activityLevel - 1 ? emptyBorderColor : borderColor}
          strokeWidth={i > 0 ? 1 : undefined}
          data-testid={`activity-level-meter_level-${i + 1}`}
          style={rectStyle}
        />
      ))}
    </svg>
  );
};

export default ActivityLevelMeterIcon;